export enum ExpirationDateDTAEnum {
  RED_WARNING = 1,
  YELLOW_WARNING = 3,
  GREEN_WARNING = 5,
};
